<template>
  <div
    class="common_heador "
    :class="{
      heador_fixed: fixed,
      common_heador_KNOWLEDGE: isILocalizeFn(),
    }"
  >
    <div class="title">
      <slot name="title-left"></slot>
      {{
        isILocalizeFn()
          ? "iLocalize Support"
          : title
      }}
      <slot name="title-right"></slot>
    </div>
    <div class="btn-wrap">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "common_heador",
  inject: ["isILocalizeFn"],
  props: {
    title: {
      type: String,
      default: "",
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    title: {
      handler(val) {
        if (!val) {
          document.title = "MFAQ";
          return;
        }
        document.title = val;
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.common_heador {
  // 变量
  $padding: 43px;
  $headerH: 100px;
  //
  z-index: 10;
  font-family: Microsoft YaHei UI;
  padding: 0 $padding;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: $headerH;
  width: 100%;
  box-sizing: border-box;
  background: #192334;
  max-width: 1200px;
  &.loading {
    position: static;
    margin-bottom: -$headerH;
  }
  .title {
    font-size: 36px;
    font-weight: 400;
    line-height: 50px;
    color: #fff;
    padding: 0;
    font-weight: bold;
  }
}
.common_heador_KNOWLEDGE {
  background-color: #008f94;
}
</style>
